import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DaoService } from '../../core/dao/dao.service';
import { IAudioPlugin } from '../../core/models/plugin.model';
import { flatMap, forkJoin, Observable, of, map, mergeMap } from 'rxjs';
import { AsyncService } from '../../core/async/async.service';

@Component({
  selector: 'app-sync',
  templateUrl: 'sync.component.html',
  styleUrls: ['./sync.component.css']
})
export class SyncComponent implements OnInit {


  constructor(
    private dao: DaoService,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private async: AsyncService) { }

  ngOnInit() {
    this.router.navigate(["home"]);
    //this.loading = true;
    //this.dao
    //  .Sync()
    //  .pipe(
    //    flatMap(result => {
    //      return this.dao.GetSubscription();
    //    }),
    //    flatMap(result => {
    //      if (!result.active) {
    //        this
    //          .async
    //          .openDialog("Warning", "Your license expired.", (answer) => {
    //            if (answer) {
    //              window.open(result.manageSubscriptionsUrl, "");
    //            } else {
    //              window.location.reload();
    //            }
    //          })
    //      } else {
    //        this.router.navigate(["home"]);
    //      }
    //      return of(result);
    //    }))
    //  .subscribe(result => { }, error => { this.toastr.error("Could not sync subscription, please reload the page", "Error"); });
  }
}
